<template>
  <v-menu class="select-menu" :style="screenWidth - 280 < 960 ? 'width: 100%' : ''" offset-y>
    <v-btn class="select-menu-button" :block="screenWidth - 280 < 960" slot="activator" color="primary" large outline dark>
      <span style="font-size: 18px; font-weight: 500; letter-spacing: 0.1em;">{{ currentState.name }}</span>
      <v-icon class="ml-2">arrow_drop_down</v-icon>
    </v-btn>
    <v-list class="states-list">
      <v-list-tile v-for="(state, index) in states" :key="index" @click="setCurrentState(state)">
        <v-list-tile-title>{{ state.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const computed = {
  ...mapGetters({
    currentState: 'elections/currentState',
    elections: 'elections/list',
    states: 'elections/states',
    mobile: 'ux/mobile',
    screenWidth: 'ux/screenWidth'
  })
}

const methods = {
  ...mapActions({
    setCurrentState: 'elections/setCurrentState',
    addState: 'elections/addState'
  })
}

export default {
  computed,
  methods,
  mounted () {
    if (document.documentElement.clientWidth > 420) {
      if (this.states.findIndex(item => item.name === 'United States') === -1) {
        this.addState({id: '00', name: 'United States'})
      }
    }
    this.setCurrentState(this.states[0])
  }
}
</script>

<style>
.select-menu {
  z-index: 450;
}

.states-list {
  height: 200px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

@media only screen and (max-width: 500px) {
  .select-menu {
    width: 100%;
    /* display: block !important; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatesList.vue